import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from './AppIcons';
const purchases = [['Olivia K.', 'New York, USA', 'SwimReady 365™'], ['Sarah M.', 'Florida, USA', 'SwimReady 365™ Complete Box Set'], ['Mark K.', 'Sydney, Australia', 'SwimReady 365™'], ['David R.', 'Toronto, Canada', 'SwimReady 365™ Complete Box Set']];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-197" data-mp="1fviyzj9m5jju">
      <div className="relative border border-[#E5E5EA] bg-white p-4 pr-10 shadow-2xl" data-id="element-198" data-mp="n6valetkie22">
        <button type="button" aria-label="Dismiss recent purchase notification" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-[#5A5A66] hover:text-[#0A0A0A]" data-id="element-199" data-mp="i81v5guq0cz9"><XIcon className="h-4 w-4" data-id="element-200" data-mp="x382c75jyhu6" /></button>
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#9b7914]" data-id="element-201" data-mp="s5ybqo6fg04r"><span className="grid h-4 w-4 place-items-center rounded-full bg-[#d4af37]" data-id="element-202" data-mp="28jes6dzz4tbv"><CheckIcon className="h-3 w-3 text-[#0A0A0A]" data-id="element-203" data-mp="23lmz3gnlf163" /></span>Verified purchase</p>
        <p className="mt-3 text-sm font-semibold text-[#0A0A0A]" data-id="element-204" data-mp="2aol6yk63qo6f"><strong data-id="element-205" data-mp="2anrz1fvepsmp">{purchase[0]}</strong> from {purchase[1]}</p>
        <p className="mt-1 text-xs font-medium text-[#5A5A66]" data-id="element-206" data-mp="2fn4u2nwfm60d">just purchased <span className="font-bold text-[#9b7914]" data-id="element-207" data-mp="2fph9atat229q">{purchase[2]}</span></p>
      </div>
    </aside>;
}